<template>
    <div class="app">
        <theme-header />
        <loading-page v-if="isLoading" />
        <router-view :key="$route.path"
                     @pageLoaded="isLoading = false"/>
        <theme-footer v-if="!isLoading" />
    </div>
</template>

<script>
    import {EventBus} from "./utils/EventBus";
    import ThemeHeader from './modules/header/ThemeHeader'
    import ThemeFooter from './modules/footer/ThemeFooter'
    import LoadingPage from './modules/includes/LoadingPage'

    export default {
        name: "App",
        components: { ThemeHeader, ThemeFooter, LoadingPage },
        data() {
            return {
                isLoading: true
            }
        },
        watch: {
            $route: {
                deep: true,
                immediate: true,
                handler(val, oldVal) {
                    EventBus.setPageLoaded(false);
                    if (!this.$route.hash) this.isLoading = true
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>